import React from 'react';
import { Box, Typography } from '@mui/material';
interface Status {
    label: string;
    color: string;
}
interface StatusLegendProps {
    statusData: Status[];
}
const StatusLegend: React.FC<StatusLegendProps> = ({ statusData }) => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                flexWrap: "wrap",
            }}
        >
            {statusData.map((status, index) => (
                <Box key={index} sx={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
                    <Box
                        sx={{
                            width: "16px",
                            height: "16px",
                            backgroundColor: status.color,
                            marginRight: "8px",
                            borderRadius: "2px",
                        }}
                    />
                    <Typography variant="body2" sx={{ fontSize: { xs: "12px", sm: "14px" } }}>
                        {status.label}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};
export default StatusLegend